import { render } from "./PeoplePromoBlockComponent.vue?vue&type=template&id=2db59316&ts=true"
import script from "./PeoplePromoBlockComponent.vue?vue&type=script&lang=ts"
export * from "./PeoplePromoBlockComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__